export const enum Plan {
  Enterprise = 'enterprise',
  Free = 'free',
  Personal = 'personal',
  Team = 'team'
}

export interface PricingParams {
  host: string;
  ide: string;
  org: string;
  pat?: string;
  scheme: string;
  service: string;
  token: string;
  user: string;
  username: string;
}

type PaddlePrice = {
  annual: boolean;
  currency: string;
  currencyCode: string;
  description: string;
  id: string;
  name: string;
  price: number;
};

export type StandardPaddleProduct = {
  description: string;
  id: string;
  name: string;
  prices: {
    annual: PaddlePrice;
    monthly: PaddlePrice;
  };
};

export type StandardPaddleProductWithAdditional = StandardPaddleProduct & {
  prices: {
    annualAdditional: PaddlePrice;
    monthlyAdditional: PaddlePrice;
  };
};

export type PaddleProducts = {
  [Plan.Personal]: StandardPaddleProduct;
  [Plan.Team]: StandardPaddleProductWithAdditional;
  [Plan.Enterprise]: StandardPaddleProductWithAdditional;
};

export const enum PricingBillingPeriod {
  Annually = 'annually',
  Monthly = 'monthly'
}
